<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">CONTENTS</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/5chap1#chap1">INTRODUCTION</a></p>
<p class="toc2"><a href="#/6chap2#chap2">On Miscellaneity; Juice-Swapping</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/7chap3#chap3">ISSUES AND ANSWERS</a></p>
<p class="toc2"><a href="#/8chap4#chap4">The Singing-Impaired</a></p>
<p class="toc2"><a href="#/9chap5#chap5">Loss: A Guide to Economics</a></p>
<p class="toc2"><a href="#/10chap6#chap6">Reagan, Begin, and God</a></p>
<p class="toc2"><a href="#/11chap7#chap7">99 Percent Foundation</a></p>
<p class="toc2"><a href="#/12chap8#chap8">Eat That Wig, Wear That Sandwich</a></p>
<p class="toc2"><a href="#/13chap9#chap9">I Think It Was Little Richard</a></p>
<p class="toc2"><a href="#/14chap10#chap10">The Socks Problem</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/15chap11#chap11">ANIMAL AND VEGETABLE SPIRITS</a></p>
<p class="toc2"><a href="#/16chap12#chap12">Chickens</a></p>
<p class="toc2"><a href="#/17chap13#chap13">Hide the Razor on April Fools’</a></p>
<p class="toc2"><a href="#/18chap14#chap14">A Near-Score of Food Songs</a></p>
<p class="toc2"><a href="#/19chap15#chap15">Corn Prone</a></p>
<p class="toc2"><a href="#/20chap16#chap16">One Pig Jumped</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/21chap17#chap17">USED WORDS</a></p>
<p class="toc2"><a href="#/22chap18#chap18">Is the Pope Capitalized?</a></p>
<p class="toc2"><a href="#/23chap19#chap19">Gryll’s State</a></p>
<p class="toc2"><a href="#/24chap20#chap20">How Miss Wren Stood in de Do’</a></p>
<p class="toc2"><a href="#/25chap21#chap21">On Hearing It Averred …</a></p>
<p class="toc2"><a href="#/26chap22#chap22">More Like a Buffalo, Please</a></p>
<p class="toc2"><a href="#/27chap23#chap23">Whose Who?</a></p>
<p class="toc2"><a href="#/28chap24#chap24">Syntax’s Tack</a></p>
<p class="toc2"><a href="#/29chap25#chap25">The New Writing Aids</a></p>
<p class="toc2"><a href="#/30chap26#chap26">Total Nudes and Bubbling Babies</a></p>
<p class="toc2"><a href="#/31chap27#chap27">Light Verse</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/32chap28#chap28">LOVE AND OTHER INDELICACIES</a></p>
<p class="toc2"><a href="#/33chap29#chap29">You Make Me Feel Like …</a></p>
<p class="toc2"><a href="#/34chap30#chap30">So This Is Male Sexuality</a></p>
<p class="toc2"><a href="#/35chap31#chap31">I’d Rather Have You</a></p>
<p class="toc2"><a href="#/36chap32#chap32">Don’t Be Rambunctious around Your Grandma …</a></p>
<p class="toc2"><a href="#/37chap33#chap33">The <i>Times:</i> No Sh*t</a></p>
<p class="toc2"><a href="#/38chap34#chap34">To Live Is to Change</a></p>
<p class="toc2"><a href="#/39chap35#chap35">The Orgasm: A Reappraisal</a></p>
<p class="toc2"><a href="#/40chap36#chap36">Valentine</a></p>
<p class="toc2"><a href="#/41chap37#chap37">The Family Jewels</a></p>
<p class="toc2"><a href="#/42chap38#chap38">Thought She Was Eve</a></p>
<p class="toc2"><a href="#/43chap39#chap39">After Pink, What?</a></p>
<p class="toc2"><a href="#/44chap40#chap40">Between Meals Song</a></p>
<p class="toc2"><a href="#/45chap41#chap41">Jealousy Song</a></p>
<p class="toc2"><a href="#/46chap42#chap42">The Wages of Fun</a></p>
<p class="toc2"><a href="#/47chap43#chap43">No Bigger than a Minute</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/48chap44#chap44">SPORTS AFIELD</a></p>
<p class="toc2"><a href="#/49chap45#chap45">Five Ives Gets Named</a></p>
<p class="toc2"><a href="#/50chap46#chap46">Why There Will Never Be a Great Bowling Novel</a></p>
<p class="toc2"><a href="#/51chap47#chap47">Ballooning with Slick</a></p>
<p class="toc2"><a href="#/52chap48#chap48">My B.P.</a></p>
<p class="toc2"><a href="#/53chap49#chap49">Merely Shot in the Head</a></p>
<p class="toc2"><a href="#/54chap50#chap50">A Bait Box of Green Jade?</a></p>
<p class="toc2"><a href="#/55chap51#chap51">Jock Lingerie</a></p>
<p class="toc2"><a href="#/56chap52#chap52">Get Out There and Make Statements!</a></p>
<p class="toc2"><a href="#/57chap53#chap53">The Presidential Sports Profile</a></p>
<p class="toc2"><a href="#/58chap54#chap54">M.D. to The Greatest</a></p>
<p class="toc2"><a href="#/59chap55#chap55">Dedicated to Fair Hooker</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/60chap56#chap56">WIRED INTO NOW</a></p>
<p class="toc2"><a href="#/61chap57#chap57">Wired Into Now</a></p>
<p class="toc2"><a href="#/62chap58#chap58">The In-House Effect</a></p>
<p class="toc2"><a href="#/63chap59#chap59">The Teeth Festival</a></p>
<p class="toc2"><a href="#/64chap60#chap60">Thinking Black Holes Through</a></p>
<p class="toc2"><a href="#/65chap61#chap61">Weekly News Quiz</a></p>
<p class="toc2"><a href="#/66chap62#chap62">That Dog Isn’t Fifteen</a></p>
<p class="toc2"><a href="#/67chap63#chap63">Notes from the Edge Conference</a></p>
<p class="toc2"><a href="#/68chap64#chap64">Facing Ismism</a></p>
<p class="toc2"><a href="#/69chap65#chap65">For the Record</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/70chap66#chap66"><i>Acknowledgments</i></a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/71about#about">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?b12b934c